import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withKeys as _withKeys, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb-actions" }
const _hoisted_3 = {
  key: 0,
  class: "msg"
}
const _hoisted_4 = {
  key: 1,
  class: "msg error"
}
const _hoisted_5 = {
  key: 2,
  class: "msg"
}
const _hoisted_6 = {
  key: 3,
  class: "dashboard-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_8 = { class: "selection-info" }
const _hoisted_9 = { class: "selection-count" }
const _hoisted_10 = { class: "selection-actions" }
const _hoisted_11 = { class: "tbl" }
const _hoisted_12 = { id: "devices-list" }
const _hoisted_13 = { class: "select-col" }
const _hoisted_14 = ["checked", "title"]
const _hoisted_15 = { class: "header-content" }
const _hoisted_16 = { class: "header-content" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "search-row" }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "search-container" }
const _hoisted_21 = { class: "select-col" }
const _hoisted_22 = ["value", "title"]
const _hoisted_23 = { class: "mono" }
const _hoisted_24 = { class: "device-cell-content" }
const _hoisted_25 = { class: "device-info-left" }
const _hoisted_26 = { class: "device-name-text" }
const _hoisted_27 = ["title"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "device-info-actions" }
const _hoisted_30 = { class: "editor-menu-wrapper" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "owner-role" }
const _hoisted_39 = { class: "owner-name" }
const _hoisted_40 = { class: "owner-id" }
const _hoisted_41 = { class: "actions" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["colspan"]
const _hoisted_46 = {
  key: 0,
  class: "pagination-controls"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "pagination-jump" }
const _hoisted_50 = ["max"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 4,
  class: "modal-mask"
}
const _hoisted_54 = { class: "modal" }
const _hoisted_55 = { style: {"margin":"6px 0 18px"} }
const _hoisted_56 = { class: "status-options" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "modal-actions" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 5,
  class: "modal-mask"
}
const _hoisted_62 = { class: "modal" }
const _hoisted_63 = {
  key: 6,
  class: "modal-mask"
}
const _hoisted_64 = { class: "modal" }
const _hoisted_65 = { style: {"margin":"6px 0 18px"} }
const _hoisted_66 = { class: "modal-actions" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = ["disabled"]
const _hoisted_69 = {
  key: 7,
  class: "modal-mask"
}
const _hoisted_70 = { class: "modal-header" }
const _hoisted_71 = {
  key: 0,
  class: "msg"
}
const _hoisted_72 = {
  key: 1,
  class: "history-content"
}
const _hoisted_73 = {
  key: 0,
  class: "msg"
}
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "history-section" }
const _hoisted_76 = { class: "info-grid" }
const _hoisted_77 = { class: "info-item" }
const _hoisted_78 = { class: "info-value" }
const _hoisted_79 = { class: "info-item" }
const _hoisted_80 = { class: "info-value" }
const _hoisted_81 = { class: "info-item" }
const _hoisted_82 = { class: "info-value" }
const _hoisted_83 = { class: "history-section" }
const _hoisted_84 = { class: "filters" }
const _hoisted_85 = ["value"]
const _hoisted_86 = { class: "events-list" }
const _hoisted_87 = {
  key: 0,
  class: "msg"
}
const _hoisted_88 = { class: "event-time" }
const _hoisted_89 = { class: "event-content" }
const _hoisted_90 = { class: "event-header" }
const _hoisted_91 = { class: "event-type" }
const _hoisted_92 = { class: "event-action" }
const _hoisted_93 = { class: "event-details" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 2 }
const _hoisted_97 = { class: "connection-detail" }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { class: "connection-detail" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = {
  key: 2,
  class: "scroll-top-wrap"
}
const _hoisted_103 = {
  key: 1,
  class: "modal-mask"
}
const _hoisted_104 = { class: "modal new-device-modal" }
const _hoisted_105 = { class: "modal-header" }
const _hoisted_106 = { style: {"margin-bottom":"0"} }
const _hoisted_107 = {
  class: "modal-content",
  style: {"margin-top":"20px"}
}
const _hoisted_108 = {
  key: 0,
  class: "step-container"
}
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = ["disabled"]
const _hoisted_113 = {
  class: "form-group",
  style: {"margin-top":"15px"}
}
const _hoisted_114 = ["disabled"]
const _hoisted_115 = {
  key: 1,
  class: "step-container"
}
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = {
  class: "form-group",
  style: {"margin-top":"15px"}
}
const _hoisted_118 = {
  class: "radio-group",
  style: {"display":"flex","gap":"20px","margin-top":"8px"}
}
const _hoisted_119 = {
  class: "radio-label",
  style: {"display":"flex","align-items":"center","gap":"8px","cursor":"pointer"}
}
const _hoisted_120 = {
  class: "radio-label",
  style: {"display":"flex","align-items":"center","gap":"8px","cursor":"pointer"}
}
const _hoisted_121 = {
  key: 0,
  class: "form-group",
  style: {"margin-top":"15px"}
}
const _hoisted_122 = { style: {"display":"flex","gap":"10px","margin-top":"8px"} }
const _hoisted_123 = {
  class: "form-group",
  style: {"margin-top":"15px"}
}
const _hoisted_124 = {
  class: "checkbox-group",
  style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)","gap":"10px","margin-top":"8px"}
}
const _hoisted_125 = ["value"]
const _hoisted_126 = {
  class: "modal-actions",
  style: {"margin-top":"30px"}
}
const _hoisted_127 = ["disabled"]

import axios from "@/axiosInstance";
import { API_URL, EDITOR_BASE_URL } from "@/config";
import dayjs from "dayjs";
import {
	ChevronDown as ChevronDownIcon,
	ChevronUp as ChevronUpIcon,
	Clock as ClockIcon,
	Database as DatabaseIcon,
	Edit as EditIcon,
	PenLine as PenLineIcon,
	Trash as TrashIcon,
	X as XIcon,
	Send as SendIcon,
	Loader2 as LoaderIcon,
} from "lucide-vue-next";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
	faAngleLeft,
	faAngleRight,
	faAnglesLeft,
	faAnglesRight,
} from "@fortawesome/free-solid-svg-icons";
import type { Ref } from "vue";
import { computed, inject, onMounted, onUnmounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";
import NotificationBell from "./NotificationBell.vue";
import PermissionRequestModal from "./PermissionRequestModal.vue";

const itemsPerPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'DevicesList',
  setup(__props) {

const me = ref<any>({});
const isAdmin = computed(() => me.value.is_admin);
const isDesktop = inject<Ref<boolean>>("isDesktop")!;
const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;

const showCrumbBell = computed(
	() => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value),
);

const devices = ref<any[]>([]);
const loading = ref(true);
const error = ref<string | null>(null);
const router = useRouter();
const searchQuery = ref("");
const currentPage = ref(1);
const currentPageInput = ref(1);
const toast = useToast();

const sortBy = ref("updatedAt");
const sortOrder = ref<"asc" | "desc">("desc");

const toggleSort = (key: string) => {
	if (sortBy.value === key) {
		sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
	} else {
		sortBy.value = key;
		sortOrder.value = "asc";
	}
};

watch(currentPage, (val) => {
	currentPageInput.value = val;
});

const selectedIds = ref<number[]>([]);

const isAllSelected = computed(() => {
	if (paginatedDevices.value.length === 0) return false;
	return paginatedDevices.value.every((d) => selectedIds.value.includes(d.id));
});

function toggleSelectAll() {
	if (isAllSelected.value) {
		const pageIds = paginatedDevices.value.map((d) => d.id);
		selectedIds.value = selectedIds.value.filter((id) => !pageIds.includes(id));
	} else {
		paginatedDevices.value.forEach((d) => {
			if (!selectedIds.value.includes(d.id)) {
				selectedIds.value.push(d.id);
			}
		});
	}
}

const jumpToPage = () => {
	let p = parseInt(String(currentPageInput.value));
	if (isNaN(p)) {
		currentPageInput.value = currentPage.value;
		return;
	}
	if (p < 1) p = 1;
	if (p > totalPages.value) p = totalPages.value;
	currentPage.value = p;
	currentPageInput.value = p;
};

const showRenameModal = ref(false);
const tempName = ref("");
const selectedDevice = ref<any | null>(null);

const showArchiveModal = ref(false);
const isBulkArchive = ref(false);
const archiveLoading = ref(false);

const showHistoryModal = ref(false);
const historyLoading = ref(false);
const deviceHistory = ref<any[]>([]);

const showStatusModal = ref(false);
const tempStatus = ref<string | null>(null);
const statusLoading = ref(false);

// Permission Modal State
const showPermissionModal = ref(false);
const permissionDevice = ref<any | null>(null);
const failedPermissionType = ref<
	"change_status" | "change_mode" | "change_thresholds"
>("change_status");

// Editor Menu State
const openEditorMenuId = ref<string | number | null>(null);

// New Device Modal State
const showNewDeviceModal = ref(false);
const newDeviceStep = ref(1);
const newDeviceForm = ref({
	email: "",
	otp: "",
	name: "",
	type: "static" as "static" | "dynamic",
	modules: [] as string[],
	lat: "",
	lng: "",
});
const otpRequestLoading = ref(false);
const otpVerifyLoading = ref(false);
const isOtpSent = ref(false);

const filteredDevices = computed(() => {
	if (!searchQuery.value) return devices.value;
	const q = searchQuery.value.toLowerCase();
	return devices.value.filter((d) => {
		return (
			d.id.toString().toLowerCase().includes(q) ||
			(d.name && d.name.toLowerCase().includes(q)) ||
			(d.status && d.status.toLowerCase().includes(q))
		);
	});
});

const sortedDevices = computed(() => {
	const result = [...filteredDevices.value];
	return result.sort((a, b) => {
		let valA = a[sortBy.value];
		let valB = b[sortBy.value];

		if (sortBy.value === "updatedAt") {
			valA = valA ? new Date(valA).getTime() : 0;
			valB = valB ? new Date(valB).getTime() : 0;
		}

		if (valA < valB) return sortOrder.value === "asc" ? -1 : 1;
		if (valA > valB) return sortOrder.value === "asc" ? 1 : -1;
		return 0;
	});
});

const paginatedDevices = computed(() => {
	const start = (currentPage.value - 1) * itemsPerPage;
	return sortedDevices.value.slice(start, start + itemsPerPage);
});

const totalPages = computed(() => {
	return Math.ceil(filteredDevices.value.length / itemsPerPage);
});

watch(searchQuery, () => {
	currentPage.value = 1;
});

/* ref al contenitore scrollabile + stato del bottone */
const historyContainer = ref<HTMLElement | null>(null);
const showScrollTop = ref(false);

// Opzioni di stato con etichette
const statusOptions = [
	{ value: "online", label: "Online", class: "on" },
	{ value: "offline", label: "Offline", class: "off" },
	{ value: "maintenance", label: "Manutenzione", class: "maintenance" },
	{ value: "error", label: "Errore", class: "error" },
];

/* -------------------------------------------------- */
/*  FILTRI CRONOLOGIA                                 */
/* -------------------------------------------------- */
const filters = [
	{ key: "status", label: "Cambio stato" },
	{ key: "connection", label: "Connessione aggiunta/rimossa" },
	{ key: "node_moved", label: "Modulo spostato" },
	{ key: "node_added", label: "Modulo aggiunto" },
];

const activeFilters = ref<string[]>([]);

async function goToEditorSchema() {
	closeEditorMenu();

	const API_BASE = (API_URL || "").replace(/\/$/, ""); // http://localhost:3000/api

	//    const editorBase = new URL("https://d12f-151-74-127-120.ngrok-free.app");
	const editorBase = new URL(
		EDITOR_BASE_URL || "https://d12f-151-74-127-120.ngrok-free.app",
	);
	console.log("editorBase =", editorBase);
	console.log("EDITOR_BASE_URL =", EDITOR_BASE_URL);

	const fakeDraftId = "1afcf8f6-a1b2-4665-bf1e-7e7799095864";

	const getTicket = async () => {
		const ticket = await axios.get(
			`${API_BASE}/auth/editor/ticket?returnTo=${editorBase}draft/${fakeDraftId}`,
		);
		console.log("ticket =", ticket);
		return ticket.data.ticketId;
	};

	const ticket = await getTicket();

	console.log("ticket =", ticket);

	//    const EDITOR_SCHEMA_URL =
	// 	//  "https://staging-editor.archimede.world/draft/1afcf8f6-a1b2-4665-bf1e-7e7799095864/9d2a8a00-32b2-473c-a5f8-2e113fc86f7b";
	// 	 `https://e8e2-151-74-127-120.ngrok-free.app/sso/
	// ${ticket} `

	// console.log("EDITOR_SCHEMA_URL =", EDITOR_SCHEMA_URL);

	const editorSchemaUrl = new URL(`/sso/${ticket}`, editorBase).toString();
	const startUrl = `${API_BASE}/auth/editor/start?returnTo=${encodeURIComponent(
		editorSchemaUrl,
	)}`;
	window.location.assign(startUrl);
}

function ownerDisplayName(d: any) {
	const u = d.user || {};
	// scegli l’ordine che preferisci: name → username → email → fallback
	return u.name || u.username || u.email || "utente";
}

function openStatusModal(device: any) {
	selectedDevice.value = device;
	tempStatus.value = device.status;
	showStatusModal.value = true;
}

function selectStatus(status: string) {
	tempStatus.value = status;
}

function getStatusClass(status: string): string {
	const statusClasses: Record<string, string> = {
		online: "on",
		offline: "off",
		maintenance: "maintenance",
		error: "error",
	};
	return statusClasses[status] || "off";
}

async function confirmStatusChange() {
	if (!selectedDevice.value || !tempStatus.value) return;

	try {
		statusLoading.value = true;
		const response = await axios.patch(
			`/devices/${selectedDevice.value.id}/change-status`,
			{ status: tempStatus.value },
			{ withCredentials: true },
		);

		// Aggiorna lo stato localmente
		selectedDevice.value.status = tempStatus.value;
		selectedDevice.value.updatedAt = response.data.updatedAt;

		toast.success(
			`Stato del dispositivo ${selectedDevice.value.name} cambiato a ${tempStatus.value}`,
			{
				position: "top-right",
				duration: 2000,
			},
		);

		showStatusModal.value = false;
	} catch (e: any) {
		// Chiudi il modale prima di mostrare l'errore
		showStatusModal.value = false;

		// Check for permission error (401 or specific message)
		const isPermissionError =
			e.response?.status === 401 ||
			(e.response?.data?.message &&
				e.response.data.message.includes("Non hai i permessi"));

		if (isPermissionError) {
			// Open Permission Request Modal
			permissionDevice.value = selectedDevice.value; // keep reference
			failedPermissionType.value = "change_status";

			// Show toast - extract full message from backend
			let msg = "Non hai i permessi";
			const responseData = e.response?.data;
			if (typeof responseData === "string") {
				msg = responseData;
			} else if (responseData?.message) {
				msg = responseData.message;
			} else if (responseData?.details) {
				msg = responseData.details;
			} else if (responseData?.error) {
				msg = responseData.error;
			}

			toast.error(msg, { position: "top-right", duration: 4000 });

			// Delay modal to let user read toast
			setTimeout(() => {
				showPermissionModal.value = true;
			}, 2500);
			return;
		}

		// Prioritize backend message: e.response.data.message or e.response.data
		const msg =
			e.response?.data?.message ||
			e.response?.data?.details ||
			e.response?.data ||
			"Errore cambio stato";
		const finalMsg = typeof msg === "object" ? JSON.stringify(msg) : msg;

		// Mostra il toast con un leggero ritardo
		setTimeout(() => {
			toast.error(finalMsg, { position: "top-right", duration: 4000 });
		}, 300);
	} finally {
		statusLoading.value = false;
	}
}

function cancelStatusChange() {
	showStatusModal.value = false;
	tempStatus.value = null;
	selectedDevice.value = null;
}

function openRenameModal(device: any) {
	selectedDevice.value = device;
	tempName.value = device.name || "";
	showRenameModal.value = true;
}

async function confirmRename() {
	const name = tempName.value.trim();
	if (!name || !selectedDevice.value) return;

	try {
		const response = await axios.post(
			`/devices/${selectedDevice.value.id}/rename`,
			{ name },
			{ withCredentials: true },
		);
		selectedDevice.value.name = response.data.name;
		selectedDevice.value.updatedAt = response.data.updatedAt;
		toast.success(`Nome del device ${selectedDevice.value.id} aggiornato!`, {
			position: "top-right",
			duration: 2000,
		});
		cancelRename();
	} catch (e: any) {
		const msg = e.response?.data?.message || "Errore rinomina";
		toast.error(msg, { position: "top-right", duration: 2500 });
	}
}

function cancelRename() {
	showRenameModal.value = false;
	tempName.value = "";
	selectedDevice.value = null;
}

function openArchiveModal(device: any) {
	selectedDevice.value = device;
	isBulkArchive.value = false;
	showArchiveModal.value = true;
}

function openBulkArchiveModal() {
	isBulkArchive.value = true;
	if (selectedIds.value.length === 1) {
		selectedDevice.value = devices.value.find(
			(d) => d.id === selectedIds.value[0],
		);
	}
	showArchiveModal.value = true;
}

async function confirmArchive() {
	if (isBulkArchive.value) {
		await confirmBulkArchive();
		return;
	}
	if (!selectedDevice.value) return;

	archiveLoading.value = true;
	try {
		await axios.post(
			`/devices/${selectedDevice.value.id}/archive`,
			{},
			{ withCredentials: true },
		);
		devices.value = devices.value.filter(
			(d) => d.id !== selectedDevice.value.id,
		);
		toast.success(`Device con id: ${selectedDevice.value.id} archiviato`, {
			position: "top-right",
			duration: 2000,
		});
		cancelArchive();
	} catch (e: any) {
		const msg = e.response?.data?.message || "Errore archiviazione";
		toast.error(msg, { position: "top-right", duration: 2500 });
	} finally {
		archiveLoading.value = false;
	}
}

async function confirmBulkArchive() {
	archiveLoading.value = true;
	let successCount = 0;
	let errorCount = 0;

	for (const id of selectedIds.value) {
		try {
			await axios.post(`/devices/${id}/archive`, {}, { withCredentials: true });
			successCount++;
		} catch (e) {
			errorCount++;
		}
	}

	if (successCount > 0) {
		devices.value = devices.value.filter(
			(d) => !selectedIds.value.includes(d.id),
		);
		toast.success(
			`${
				selectedIds.value.length > 1 ? "Dispositivi" : "Dispositivo"
			} archiviat${selectedIds.value.length > 1 ? "i" : "o"} con successo`,
			{
				position: "top-right",
				duration: 3000,
			},
		);
	}

	if (errorCount > 0) {
		toast.error(`Errore durante l'archiviazione di ${errorCount} dispositivi`, {
			position: "top-right",
			duration: 3000,
		});
	}

	selectedIds.value = [];
	cancelArchive();
	archiveLoading.value = false;
}

function cancelArchive() {
	showArchiveModal.value = false;
	isBulkArchive.value = false;
	selectedDevice.value = null;
}

/* mostra / nasconde il bottone in base allo scroll */
function onScroll() {
	if (!historyContainer.value) return;
	showScrollTop.value = historyContainer.value.scrollTop > 300; // soglia px
}

/* scorri dolcemente fino in cima */
function scrollToTop() {
	historyContainer.value?.scrollTo({ top: 0, behavior: "smooth" });
}

function parseDetails(raw: any) {
	if (raw == null) return {};
	// se è già un oggetto lo restituisco subito
	if (typeof raw === "object") return raw;
	// altrimenti provo a fare il parse
	try {
		return JSON.parse(raw as string);
	} catch {
		console.warn("Dettagli non parsabili:", raw);
		return {};
	}
}

const processedHistory = computed(() => {
	const raw = [...deviceHistory.value]; // copia per non mutare
	const result: any[] = [];

	for (let i = 0; i < raw.length; i++) {
		const cur = raw[i];
		const d = parseDetails(cur.details);

		/* ───── STATUS ───── */
		if (cur.type === "status" || cur.eventType === "status_change") {
			result.push({
				...cur,
				type: "status",
				filterKey: "status",
				details: {
					oldStatus: d.oldStatus ?? d.old_status,
					newStatus: d.newStatus ?? d.new_status,
				},
			});
			continue;
		}

		/* ───── CONNESSIONI ───── */
		if (cur.type === "connection") {
			result.push({
				...cur,
				filterKey: "connection",
				details: {
					...cur.details,
					display_source:
						cur.details.source_label || cur.details.source_node_id || "N/A",
					display_target:
						cur.details.target_label || cur.details.target_node_id || "N/A",
					display_output:
						cur.details.source_output === "value"
							? "—"
							: cur.details.source_output,
					display_input:
						cur.details.target_input === "value"
							? "—"
							: cur.details.target_input,
				},
			});
			continue;
		}

		/* ───── NODI (add / move) ───── */
		if (cur.type === "node") {
			const base = {
				...cur,
				type: "node",
				details: {
					...cur.details,
					x: Math.round(cur.details.x),
					y: Math.round(cur.details.y),
				},
			};

			if (cur.type === "node" && cur.eventType === "modified") {
				// se cambiano solo x,y e non altri campi
				const { old, new: nu } = parseDetails(cur.details);
				if (old.x !== nu.x || old.y !== nu.y) {
					result.push({
						...cur,
						filterKey: "node_moved",
						processedType: "moved",
						oldPosition: { x: Math.round(old.x), y: Math.round(old.y) },
						details: {
							x: Math.round(nu.x),
							y: Math.round(nu.y),
							label: nu.label,
						},
					});
					continue;
				}
			}

			/* “added + removed” → spostamento */
			if (cur.eventType === "added") {
				const removedIdx = raw.findIndex(
					(e) =>
						e.type === "node" &&
						e.eventType === "removed" &&
						e.nodeId === cur.nodeId,
				);

				if (removedIdx !== -1) {
					const removedEvt = raw[removedIdx];
					result.push({
						...base,
						filterKey: "node_moved",
						processedType: "moved",
						oldPosition: {
							x: Math.round(removedEvt.details.x),
							y: Math.round(removedEvt.details.y),
						},
					});
					raw.splice(removedIdx, 1); // non serve più il “removed”
					continue;
				}
			}

			/* semplice “added” */
			if (cur.eventType === "added") {
				result.push({ ...base, filterKey: "node_added" });
				continue;
			}

			/* tutto il resto resta “node” generico (se ti serve) */
			result.push({ ...base, filterKey: "node_generic" });
			continue;
		}

		/* fallback: evento sconosciuto */
		result.push({ ...cur, filterKey: "other" });
	}

	/* ordine cronologico desc. */
	return result.sort(
		(a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
	);
});

/** ➜ Applica i checkbox: mostra SOLO gli eventi il cui filterKey è selezionato */
const filteredHistory = computed(() => {
	if (!activeFilters.value.length) return processedHistory.value;

	const active = new Set(activeFilters.value);
	return processedHistory.value.filter((ev) => active.has(ev.filterKey));
});

// function goToRecords() {
//   if (!selectedDevice.value) return;

//   router.push({
//     name: "Records",
//     params: { deviceId: selectedDevice.value.id },
//   });
// }

async function loadDeviceHistory(deviceId: any) {
	historyLoading.value = true;
	try {
		const { data } = await axios.get(`${API_URL}/devices/${deviceId}/history`);
		deviceHistory.value = [
			...(data.statusChanges || []),
			...(data.nodeChanges || []),
			...(data.connectionChanges || []),
		].sort(
			(a, b) =>
				new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
		);
		// console.log("device history", deviceHistory.value);
	} catch (error) {
		toast.error(
			`Errore nel caricamento della cronologia del device con id: ${deviceId}`,
			{
				position: "top-right",
				duration: 2500,
			},
		);
	} finally {
		historyLoading.value = false;
	}
}

function getEventTypeLabel(event: { type: string }) {
	const types: Record<string, string> = {
		status: "Stato",
		node: "Modulo",
		connection: "Connessione",
	};
	return types[event.type] || "Evento";
}

function getActionLabel(event: any): string {
	// console.log("Event", event);
	if (event.processedType === "moved") return "Spostato";
	if (event.processedType === "reconnected") return "Riconfigurata";

	const actions: Record<string, string> = {
		added: "Aggiunto",
		removed: "Rimosso",
		modified: "Modificato",
		status_change: "Cambiato",
	};
	// Aggiungi suffissi di genere in base al type
	const baseAction =
		actions[event.eventType] || event.eventType || "Modificato";

	if (event.type === "connection") {
		return baseAction.replace(/o$/, "a"); // Trasforma in femminile
	}

	return baseAction;
}

async function fetchMe() {
	try {
		const { data } = await axios.get("/auth/me", { withCredentials: true });
		me.value = data; // <-- popola isAdmin
	} catch {
		me.value = {};
	}
}

async function loadDevices() {
	loading.value = true;
	try {
		const params: any = {};
		if (isAdmin.value) params.all = true; // per admin => vede tutti i dispositivi sia suoi che degli altri utenti

		const { data, status } = await axios.get("/devices/get-all-graphs", {
			params,
			withCredentials: true,
		});

		// Gestione esplicita dello status 204 => quando non ci sono dispositivi
		if (status === 204) {
			devices.value = [];
			toast.info("Nessun dispositivo trovato", {
				position: "top-right",
				duration: 2000,
			});
			return;
		}

		// Filtra i dispositivi non archiviati
		devices.value = (data ?? []).filter((g: any) => g.is_archived === false);

		if (devices.value.length === 0) {
			toast.info("Nessun dispositivo attivo trovato", {
				position: "top-right",
				duration: 2000,
			});
		}
	} catch (e: any) {
		error.value = e.response?.data?.details || "Errore caricamento";
		toast.error("Errore nel caricamento dei dispositivi", {
			position: "top-right",
			duration: 2000,
		});
	} finally {
		loading.value = false;
	}
}

function openNewDeviceModal() {
	newDeviceStep.value = 1;
	newDeviceForm.value = {
		email: "",
		otp: "",
		name: "",
		type: "static",
		modules: [],
		lat: "",
		lng: "",
	};
	isOtpSent.value = false;
	showNewDeviceModal.value = true;
}

async function requestOtp() {
	if (!newDeviceForm.value.email) return;

	otpRequestLoading.value = true;
	try {
		await axios.post(`${API_URL}/devices/device/request-otp`, {
			email: newDeviceForm.value.email,
		});

		toast.success("Codice OTP inviato con successo! Controlla la tua email.", {
			position: "top-right",
			duration: 3000,
		});
		isOtpSent.value = true;
	} catch (e: any) {
		const msg = e.response?.data?.message || "Errore invio OTP";
		toast.error(msg, { position: "top-right", duration: 3000 });
	} finally {
		otpRequestLoading.value = false;
	}
}

async function nextNewDeviceStep() {
	if (newDeviceStep.value === 1) {
		if (!isOtpSent.value) {
			toast.warning("Devi prima richiedere il codice OTP", {
				position: "top-right",
			});
			return;
		}

		if (!newDeviceForm.value.otp) {
			toast.warning("Inserisci il codice OTP", { position: "top-right" });
			return;
		}

		otpVerifyLoading.value = true;
		try {
			await axios.post(`${API_URL}/devices/device/verify-otp`, {
				otpCode: newDeviceForm.value.otp,
			});

			// Verify success -> Proceed to Step 2

			// Genera un nome randomico se vuoto
			if (!newDeviceForm.value.name) {
				const adjectives = [
					"Smart",
					"Quick",
					"Bright",
					"Swift",
					"Active",
					"Dynamic",
					"Rapid",
					"Agile",
				];
				const nouns = [
					"Device",
					"Sensor",
					"Monitor",
					"Tracker",
					"Unit",
					"Node",
					"Station",
					"Hub",
				];
				const randomAdj =
					adjectives[Math.floor(Math.random() * adjectives.length)];
				const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
				const randomNum = Math.floor(Math.random() * 1000);
				newDeviceForm.value.name = `${randomAdj}-${randomNoun}-${randomNum}`;
			}

			newDeviceStep.value = 2;
		} catch (e: any) {
			const msg =
				e.response?.data?.message || "Codice OTP non valido o scaduto";
			toast.error(msg, { position: "top-right", duration: 3000 });
		} finally {
			otpVerifyLoading.value = false;
		}
	}
}

async function confirmNewDevice() {
	// Logica di creazione (per ora simulata come richiesto)
	console.log("Creazione device con dati:", newDeviceForm.value);

	try {
		// In futuro qui andrà la chiamata reale
		const lat = parseFloat(newDeviceForm.value.lat);
		const lng = parseFloat(newDeviceForm.value.lng);
		const hasLocation = !isNaN(lat) && !isNaN(lng);

		const response = await axios.post(
			`${API_URL}/devices/device/complete-creation`,
			{
				name: newDeviceForm.value.name,
				is_static: newDeviceForm.value.type === "static",
				has_sat: newDeviceForm.value.modules.includes("sat"),
				has_lora: newDeviceForm.value.modules.includes("lora"),
				has_lte: newDeviceForm.value.modules.includes("lte"),
				has_plc: newDeviceForm.value.modules.includes("plc"),
				...(hasLocation && { location: [lat, lng] }),
			},
		);

		toast.success(
			`Nuovo Device con id: ${response.data.id} aggiunto con successo`,
			{
				position: "top-right",
				duration: 2000,
			},
		);

		showNewDeviceModal.value = false;
		await loadDevices();
	} catch (e: any) {
		const msg = e.response?.data?.message || "Errore creazione device";
		toast.error(msg, { position: "top-right", duration: 3000 });
	}
}

async function newDevice() {
	openNewDeviceModal();
}

function formatDate(iso: string) {
	return dayjs(iso).format("DD/MM/YYYY HH:mm");
}

function formatTime(iso: string) {
	return dayjs(iso).format("HH:mm");
}

function listModules(d: any) {
	return d.nodes?.map((n: any) => n.label).join(", ") || "—";
}

function rename(device: any) {
	openRenameModal(device);
}

function openData(d: any) {
	router.push({ name: "Data", params: { deviceId: d.id } });
}

function edit(d: any) {
	router.push({ name: "Editor", params: { deviceId: d.id } });
	closeEditorMenu();
}

function openSchema(_d: any) {
	goToEditorSchema();
}

function toggleEditorMenu(id: string | number) {
	if (openEditorMenuId.value === id) {
		openEditorMenuId.value = null;
	} else {
		openEditorMenuId.value = id;
	}
}

function closeEditorMenu() {
	openEditorMenuId.value = null;
}

function handleClickOutside(event: MouseEvent) {
	const target = event.target as HTMLElement;
	if (!target.closest(".editor-menu-wrapper")) {
		closeEditorMenu();
	}
}

async function log(d: any) {
	selectedDevice.value = d;
	showHistoryModal.value = true;
	await loadDeviceHistory(d.id);
}

function del(device: any) {
	openArchiveModal(device);
}

/*  ▸  quando apro/chiudo la history-modal
       – su viewport < 1023 px aggiungo/tolgo una
         classe al <body> che fa “sparire” la sidebar       */
watch(showHistoryModal, (open: any) => {
	if (window.innerWidth < 1023) {
		document.body.classList.toggle("hist-open", open);
	}
});

onMounted(async () => {
	document.addEventListener("click", handleClickOutside);
	await fetchMe();
	await loadDevices();
});

onUnmounted(() => {
	document.removeEventListener("click", handleClickOutside);
});

window.addEventListener("graph-restored", async () => {
	await loadDevices();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("header", _hoisted_1, [
        _cache[26] || (_cache[26] = _createElementVNode("span", null, "Devices", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            id: "btn-new-device",
            class: "btn-new",
            onClick: newDevice
          }, " + Nuovo device "),
          (isAdmin.value)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                class: "btn-new",
                to: { name: 'ArchivedDevices' }
              }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                  _createTextVNode(" Archiviati ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showCrumbBell.value)
            ? (_openBlock(), _createBlock(NotificationBell, {
                key: 1,
                placement: "header"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Caricamento…"))
        : (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
          : (!devices.value.length && !loading.value && !error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Nessun dispositivo presente "))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_Transition, { name: "slide-fade" }, {
                  default: _withCtx(() => [
                    (selectedIds.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                              class: "btn-close-selection",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedIds.value = [])),
                              title: "Annulla selezione"
                            }, [
                              _createVNode(_unref(XIcon))
                            ]),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(selectedIds.value.length) + " selezionati", 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                              class: "btn-selection-action archive",
                              onClick: openBulkArchiveModal,
                              title: "Archivia selezionati"
                            }, [
                              _createVNode(_unref(TrashIcon)),
                              _cache[27] || (_cache[27] = _createElementVNode("span", null, "Archivia", -1))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("div", {
                  class: "tbl-wrap",
                  style: _normalizeStyle({ marginTop: selectedIds.value.length > 0 ? '10px' : '50px' })
                }, [
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", _hoisted_12, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_13, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: isAllSelected.value,
                            onChange: toggleSelectAll,
                            title: 
										isAllSelected.value
											? 'Deseleziona tutti i device'
											: 'Seleziona tutti i device'
									
                          }, null, 40, _hoisted_14)
                        ]),
                        _createElementVNode("th", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('id'))),
                          class: "sortable"
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[28] || (_cache[28] = _createTextVNode(" ID ", -1)),
                            (_openBlock(), _createBlock(_resolveDynamicComponent(
											sortBy.value === 'id'
												? sortOrder.value === 'asc'
													? _unref(ChevronUpIcon)
													: _unref(ChevronDownIcon)
												: 'span'
										), { class: "sort-icon" }))
                          ])
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("th", null, "Nome", -1)),
                        _cache[31] || (_cache[31] = _createElementVNode("th", null, "Status", -1)),
                        _cache[32] || (_cache[32] = _createElementVNode("th", null, "Moduli connessi", -1)),
                        _createElementVNode("th", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('updatedAt'))),
                          class: "sortable"
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[29] || (_cache[29] = _createTextVNode(" Last Update ", -1)),
                            (_openBlock(), _createBlock(_resolveDynamicComponent(
											sortBy.value === 'updatedAt'
												? sortOrder.value === 'asc'
													? _unref(ChevronUpIcon)
													: _unref(ChevronDownIcon)
												: 'span'
										), { class: "sort-icon" }))
                          ])
                        ]),
                        (isAdmin.value)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Proprietario"))
                          : _createCommentVNode("", true),
                        _cache[33] || (_cache[33] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_18, [
                        _createElementVNode("td", {
                          colspan: isAdmin.value ? 8 : 7
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                              type: "text",
                              placeholder: "Cerca per ID, Nome o Status...",
                              class: "search-input"
                            }, null, 512), [
                              [_vModelText, searchQuery.value]
                            ])
                          ])
                        ], 8, _hoisted_19)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDevices.value, (d, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: d.id,
                          class: _normalizeClass(i % 2 && 'alt')
                        }, [
                          _createElementVNode("td", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: d.id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedIds).value = $event)),
                              title: 
										selectedIds.value.includes(d.id)
											? 'Deseleziona questo device'
											: 'Seleziona questo device'
									
                            }, null, 8, _hoisted_22), [
                              [_vModelCheckbox, selectedIds.value]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(d.id), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(d.name || "—"), 1),
                                (d.is_shared)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "shared-device-badge",
                                      title: `Condiviso da ${d.shared_by_name || 'Admin'}`
                                    }, " 🔗 Condiviso ", 8, _hoisted_27))
                                  : _createCommentVNode("", true),
                                (d.name)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "rename-btn",
                                      title: "Rinomina",
                                      onClick: ($event: any) => (rename(d))
                                    }, [
                                      _createVNode(_unref(PenLineIcon))
                                    ], 8, _hoisted_28))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("button", {
                                    class: "btn-action-labeled",
                                    title: "Scegli Editor",
                                    onClick: _withModifiers(($event: any) => (toggleEditorMenu(d.id)), ["stop"])
                                  }, [
                                    _createVNode(_unref(EditIcon)),
                                    _cache[34] || (_cache[34] = _createElementVNode("span", null, "Editor", -1)),
                                    _createVNode(_unref(ChevronDownIcon), { class: "chevron-icon" })
                                  ], 8, _hoisted_31),
                                  (openEditorMenuId.value === d.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("button", {
                                          class: "menu-item",
                                          onClick: ($event: any) => (edit(d))
                                        }, [...(_cache[35] || (_cache[35] = [
                                          _createElementVNode("span", null, "Logica", -1)
                                        ]))], 8, _hoisted_33),
                                        _createElementVNode("button", {
                                          class: "menu-item",
                                          onClick: ($event: any) => (openSchema(d))
                                        }, [...(_cache[36] || (_cache[36] = [
                                          _createElementVNode("span", null, "Schema", -1)
                                        ]))], 8, _hoisted_34)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "btn-action-labeled",
                                  title: "Data",
                                  onClick: ($event: any) => (openData(d))
                                }, [
                                  _createVNode(_unref(DatabaseIcon)),
                                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "Data", -1))
                                ], 8, _hoisted_35)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "status-btn",
                              onClick: ($event: any) => (openStatusModal(d)),
                              title: `Cambia stato (attuale: ${d.status})`
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["status-dot", getStatusClass(d.status)])
                              }, null, 2),
                              _createVNode(_unref(ChevronDownIcon), { class: "status-edit-icon" })
                            ], 8, _hoisted_36)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(listModules(d)), 1),
                          _createElementVNode("td", null, _toDisplayString(formatDate(d.updatedAt)), 1),
                          (isAdmin.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["owner-badge", d.user?.is_admin ? 'admin' : 'user'])
                                }, [
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(d.user?.is_admin ? "Admin" : "User"), 1),
                                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "owner-sep" }, "•", -1)),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(ownerDisplayName(d)), 1),
                                  _createElementVNode("span", _hoisted_40, "(#" + _toDisplayString(d.user?.id ?? d.user_id) + ")", 1)
                                ], 2)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_41, [
                            (selectedIds.value.length === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("button", {
                                    title: "Cronologia",
                                    onClick: ($event: any) => (log(d))
                                  }, [
                                    _createVNode(_unref(ClockIcon))
                                  ], 8, _hoisted_42),
                                  _createElementVNode("button", {
                                    class: "btn-action-archive",
                                    title: "Archivia",
                                    onClick: ($event: any) => (del(d))
                                  }, [
                                    _createVNode(_unref(TrashIcon))
                                  ], 8, _hoisted_43)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128)),
                      (searchQuery.value && !filteredDevices.value.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                            _createElementVNode("td", {
                              colspan: isAdmin.value ? 8 : 7,
                              class: "msg-row",
                              style: {"text-align":"center","padding":"24px","color":"#666","background":"#fff"}
                            }, " Nessun risultato trovato per \"" + _toDisplayString(searchQuery.value) + "\" ", 9, _hoisted_45)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 4), [
                  [_vShow, devices.value.length]
                ]),
                (totalPages.value > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("button", {
                        class: "btn-pagination",
                        disabled: currentPage.value === 1,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value = 1)),
                        title: "Vai alla prima pagina"
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesLeft) }, null, 8, ["icon"])
                      ], 8, _hoisted_47),
                      _createElementVNode("button", {
                        class: "btn-pagination",
                        disabled: currentPage.value === 1,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (currentPage.value--)),
                        title: "Vai alla pagina precedente"
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleLeft) }, null, 8, ["icon"])
                      ], 8, _hoisted_48),
                      _createElementVNode("div", _hoisted_49, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", null, "Pagina", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentPageInput).value = $event)),
                          onKeyup: _withKeys(jumpToPage, ["enter"]),
                          onBlur: jumpToPage,
                          min: "1",
                          max: totalPages.value,
                          class: "jump-input"
                        }, null, 40, _hoisted_50), [
                          [_vModelText, currentPageInput.value]
                        ]),
                        _createElementVNode("span", null, "di " + _toDisplayString(totalPages.value), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn-pagination",
                        disabled: currentPage.value === totalPages.value,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (currentPage.value++)),
                        title: "Vai alla pagina successiva"
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleRight) }, null, 8, ["icon"])
                      ], 8, _hoisted_51),
                      _createElementVNode("button", {
                        class: "btn-pagination",
                        disabled: currentPage.value === totalPages.value,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (currentPage.value = totalPages.value)),
                        title: "Vai all'ultima pagina"
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesRight) }, null, 8, ["icon"])
                      ], 8, _hoisted_52)
                    ]))
                  : _createCommentVNode("", true)
              ])),
      (showStatusModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Cambio stato dispositivo", -1)),
              _createElementVNode("p", _hoisted_55, [
                _cache[40] || (_cache[40] = _createTextVNode(" Seleziona il nuovo stato per ", -1)),
                _createElementVNode("strong", null, _toDisplayString(selectedDevice.value?.name || selectedDevice.value?.id), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                  return _createElementVNode("button", {
                    key: status.value,
                    onClick: ($event: any) => (selectStatus(status.value)),
                    class: _normalizeClass({ active: tempStatus.value === status.value })
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status-dot", status.class])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(status.label), 1)
                  ], 10, _hoisted_57)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("button", {
                  disabled: !tempStatus.value || statusLoading.value,
                  onClick: confirmStatusChange
                }, " Conferma ", 8, _hoisted_59),
                _createElementVNode("button", {
                  disabled: statusLoading.value,
                  onClick: cancelStatusChange
                }, " Annulla ", 8, _hoisted_60)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showRenameModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _cache[42] || (_cache[42] = _createElementVNode("h3", null, "Nome del device", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((tempName).value = $event)),
                class: "modal-input",
                placeholder: "Es. Weather-Station-01"
              }, null, 512), [
                [_vModelText, tempName.value]
              ]),
              _createElementVNode("div", { class: "modal-actions" }, [
                _createElementVNode("button", { onClick: confirmRename }, "OK"),
                _createElementVNode("button", { onClick: cancelRename }, "Annulla")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showArchiveModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("h3", null, _toDisplayString(isBulkArchive.value ? "Archivia devices selezionati" : "Archivia device"), 1),
              _createElementVNode("p", _hoisted_65, [
                (selectedIds.value.length > 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[43] || (_cache[43] = _createTextVNode(" Vuoi davvero archiviare i ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(selectedIds.value.length), 1),
                      _cache[44] || (_cache[44] = _createTextVNode(" dispositivi selezionati? ", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[45] || (_cache[45] = _createTextVNode(" Vuoi davvero archiviare il device ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(selectedDevice.value?.name ||
							selectedDevice.value?.id ||
							(selectedIds.value.length === 1 ? selectedIds.value[0] : "")), 1),
                      _cache[46] || (_cache[46] = _createTextVNode("? ", -1))
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  disabled: archiveLoading.value,
                  onClick: confirmArchive
                }, "OK", 8, _hoisted_67),
                _createElementVNode("button", {
                  disabled: archiveLoading.value,
                  onClick: cancelArchive
                }, " Annulla ", 8, _hoisted_68)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showHistoryModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _createElementVNode("div", {
              class: "modal history-modal",
              ref_key: "historyContainer",
              ref: historyContainer,
              onScroll: onScroll
            }, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("h3", null, " Cronologia del device '" + _toDisplayString(selectedDevice.value?.name || selectedDevice.value?.id) + "' ", 1),
                _createElementVNode("button", {
                  class: "modal-close",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (showHistoryModal.value = false)),
                  title: "Chiudi"
                }, [
                  _createVNode(_unref(XIcon))
                ])
              ]),
              (historyLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, "Caricamento cronologia..."))
                : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    (!deviceHistory.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, " Nessun evento registrato "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _cache[50] || (_cache[50] = _createElementVNode("h4", null, "Informazioni Base", -1)),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "info-label" }, "Creato il:", -1)),
                                _createElementVNode("span", _hoisted_78, _toDisplayString(formatDate(selectedDevice.value.createdAt)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "info-label" }, "Ultimo aggiornamento:", -1)),
                                _createElementVNode("span", _hoisted_80, _toDisplayString(formatDate(selectedDevice.value.updatedAt)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "info-label" }, "Stato attuale:", -1)),
                                _createElementVNode("span", _hoisted_82, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["status-dot", getStatusClass(selectedDevice.value.status)])
                                  }, null, 2),
                                  _createElementVNode("span", null, _toDisplayString(selectedDevice.value.status || "online"), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _cache[58] || (_cache[58] = _createElementVNode("h4", null, "Eventi", -1)),
                            _createElementVNode("div", _hoisted_84, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filters, (f) => {
                                return _createElementVNode("label", {
                                  key: f.key,
                                  class: "filter-item"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((activeFilters).value = $event)),
                                    value: f.key
                                  }, null, 8, _hoisted_85), [
                                    [_vModelCheckbox, activeFilters.value]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(f.label), 1)
                                ])
                              }), 64)),
                              (activeFilters.value.length)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "filters-reset",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (activeFilters.value = []))
                                  }, " Azzera filtri "))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              (!filteredHistory.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, " Nessun evento corrispondente ai filtri correnti "))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredHistory.value, (event) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: event.id,
                                      class: _normalizeClass(["event-item", [
											event.type,
											event.processedType || event.eventType,
										]])
                                    }, [
                                      _createElementVNode("div", _hoisted_88, _toDisplayString(formatDate(event.timestamp)), 1),
                                      _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _createElementVNode("span", _hoisted_91, _toDisplayString(getEventTypeLabel(event)), 1),
                                          _createElementVNode("span", _hoisted_92, _toDisplayString(getActionLabel(event)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_93, [
                                          (event.type === 'status')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[51] || (_cache[51] = _createElementVNode("span", null, "da ", -1)),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["status-value", getStatusClass(event.details.oldStatus)])
                                                }, _toDisplayString(event.details.oldStatus), 3),
                                                _cache[52] || (_cache[52] = _createElementVNode("span", null, " a ", -1)),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["status-value", getStatusClass(event.details.newStatus)])
                                                }, _toDisplayString(event.details.newStatus), 3)
                                              ], 64))
                                            : (
														event.type === 'node' &&
														event.processedType === 'moved'
													)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createElementVNode("strong", null, _toDisplayString(event.details.label || event.nodeId), 1),
                                                  _createElementVNode("span", null, " spostato da (" + _toDisplayString(event.oldPosition.x) + ", " + _toDisplayString(event.oldPosition.y) + ")", 1),
                                                  _createElementVNode("span", null, " a (" + _toDisplayString(event.details.x) + ", " + _toDisplayString(event.details.y) + ")", 1)
                                                ], 64))
                                              : (event.type === 'connection')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    (
															event.details.display_source ===
															event.details.display_target
														)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_94, " dallo "))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_95, " tra ")),
                                                    (
															event.details.display_source ===
															event.details.display_target
														)
                                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_96, "stesso modulo"))
                                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                          _createElementVNode("strong", null, _toDisplayString(event.details.display_source), 1),
                                                          _cache[53] || (_cache[53] = _createElementVNode("span", null, " e ", -1)),
                                                          _createElementVNode("strong", null, _toDisplayString(event.details.display_target), 1)
                                                        ], 64)),
                                                    (
															event.details.display_output !== '—' ||
															event.details.display_input !== '—'
														)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                          _cache[56] || (_cache[56] = _createElementVNode("span", null, " (", -1)),
                                                          (event.details.display_output !== '—')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _cache[54] || (_cache[54] = _createElementVNode("span", null, "output: ", -1)),
                                                                _createElementVNode("span", _hoisted_97, _toDisplayString(event.details.display_output), 1)
                                                              ], 64))
                                                            : _createCommentVNode("", true),
                                                          (
																event.details.display_output !== '—' &&
																event.details.display_input !== '—'
															)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_98, ", "))
                                                            : _createCommentVNode("", true),
                                                          (event.details.display_input !== '—')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                _cache[55] || (_cache[55] = _createElementVNode("span", null, "input: ", -1)),
                                                                _createElementVNode("span", _hoisted_99, _toDisplayString(event.details.display_input), 1)
                                                              ], 64))
                                                            : _createCommentVNode("", true),
                                                          _cache[57] || (_cache[57] = _createElementVNode("span", null, ")", -1))
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : (
														event.type === 'node' &&
														event.processedType === 'moved'
													)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                      _createElementVNode("strong", null, _toDisplayString(event.details.label || event.nodeId), 1),
                                                      _createElementVNode("span", null, " spostato da (" + _toDisplayString(event.oldPosition.x) + ", " + _toDisplayString(event.oldPosition.y) + ")", 1),
                                                      _createElementVNode("span", null, " a (" + _toDisplayString(event.details.x) + ", " + _toDisplayString(event.details.y) + ")", 1)
                                                    ], 64))
                                                  : (event.type === 'node')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                        _createElementVNode("strong", null, _toDisplayString(event.details.label || event.nodeId), 1),
                                                        (event.eventType === 'added')
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_100, " aggiunto in posizione (" + _toDisplayString(event.details.x) + ", " + _toDisplayString(event.details.y) + ")", 1))
                                                          : _createCommentVNode("", true),
                                                        (event.eventType === 'removed')
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_101, " rimosso dalla posizione (" + _toDisplayString(event.details.x) + ", " + _toDisplayString(event.details.y) + ")", 1))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 2))
                                  }), 128))
                            ])
                          ])
                        ]))
                  ])),
              (showScrollTop.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                    (showScrollTop.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "scroll-top-btn",
                          onClick: scrollToTop,
                          title: "Torna all’inizio"
                        }, [
                          _createVNode(_unref(ChevronUpIcon))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 544)
          ]))
        : _createCommentVNode("", true)
    ]),
    (showPermissionModal.value)
      ? (_openBlock(), _createBlock(PermissionRequestModal, {
          key: 0,
          deviceId: permissionDevice.value?.id,
          deviceName: permissionDevice.value?.name,
          permissionType: failedPermissionType.value,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (showPermissionModal.value = false))
        }, null, 8, ["deviceId", "deviceName", "permissionType"]))
      : _createCommentVNode("", true),
    (showNewDeviceModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("h3", _hoisted_106, _toDisplayString(newDeviceStep.value === 1
							? "Nuovo Device - Step 1/2"
							: "Nuovo Device - Step 2/2"), 1),
              _createElementVNode("button", {
                class: "modal-close",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (showNewDeviceModal.value = false))
              }, [
                _createVNode(_unref(XIcon))
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              (newDeviceStep.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _cache[59] || (_cache[59] = _createElementVNode("label", { class: "modal-label" }, "Email", -1)),
                      _createElementVNode("div", _hoisted_110, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newDeviceForm.value.email) = $event)),
                          type: "email",
                          placeholder: "Conferma l'email",
                          class: "modal-input",
                          disabled: isOtpSent.value || otpRequestLoading.value
                        }, null, 8, _hoisted_111), [
                          [_vModelText, newDeviceForm.value.email]
                        ]),
                        (!isOtpSent.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: requestOtp,
                              disabled: !newDeviceForm.value.email || otpRequestLoading.value,
                              class: "btn-otp"
                            }, [
                              (otpRequestLoading.value)
                                ? (_openBlock(), _createBlock(_unref(LoaderIcon), {
                                    key: 0,
                                    class: "animate-spin"
                                  }))
                                : (_openBlock(), _createBlock(_unref(SendIcon), { key: 1 })),
                              _createElementVNode("span", null, _toDisplayString(otpRequestLoading.value ? "Invio..." : "Invia Codice OTP"), 1)
                            ], 8, _hoisted_112))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _cache[60] || (_cache[60] = _createElementVNode("label", { class: "modal-label" }, "Codice OTP", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newDeviceForm.value.otp) = $event)),
                        type: "text",
                        placeholder: "Inserisci il codice OTP ricevuto via email",
                        class: "modal-input",
                        disabled: !isOtpSent.value || otpVerifyLoading.value
                      }, null, 8, _hoisted_114), [
                        [_vModelText, newDeviceForm.value.otp]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (newDeviceStep.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _cache[61] || (_cache[61] = _createElementVNode("label", { class: "modal-label" }, "NOME", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((newDeviceForm.value.name) = $event)),
                        type: "text",
                        placeholder: "Inserisci il nome del device",
                        class: "modal-input"
                      }, null, 512), [
                        [_vModelText, newDeviceForm.value.name]
                      ]),
                      _cache[62] || (_cache[62] = _createElementVNode("p", { class: "field-hint" }, " Puoi modificarlo ora o successivamente dalla lista device. ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_117, [
                      _cache[65] || (_cache[65] = _createElementVNode("label", { class: "modal-label" }, "TIPOLOGIA", -1)),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("label", _hoisted_119, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "static",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((newDeviceForm.value.type) = $event)),
                            style: {"width":"18px","height":"18px","accent-color":"#008f8f"}
                          }, null, 512), [
                            [_vModelRadio, newDeviceForm.value.type]
                          ]),
                          _cache[63] || (_cache[63] = _createTextVNode(" Statico ", -1))
                        ]),
                        _createElementVNode("label", _hoisted_120, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: "dynamic",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((newDeviceForm.value.type) = $event)),
                            style: {"width":"18px","height":"18px","accent-color":"#008f8f"}
                          }, null, 512), [
                            [_vModelRadio, newDeviceForm.value.type]
                          ]),
                          _cache[64] || (_cache[64] = _createTextVNode(" Dinamico ", -1))
                        ])
                      ])
                    ]),
                    (newDeviceForm.value.type === 'static')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          _cache[66] || (_cache[66] = _createElementVNode("label", { class: "modal-label" }, "POSIZIONE (opzionale)", -1)),
                          _createElementVNode("div", _hoisted_122, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((newDeviceForm.value.lat) = $event)),
                              type: "number",
                              step: "any",
                              placeholder: "Latitudine",
                              class: "modal-input"
                            }, null, 512), [
                              [_vModelText, newDeviceForm.value.lat]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((newDeviceForm.value.lng) = $event)),
                              type: "number",
                              step: "any",
                              placeholder: "Longitudine",
                              class: "modal-input"
                            }, null, 512), [
                              [_vModelText, newDeviceForm.value.lng]
                            ])
                          ]),
                          _cache[67] || (_cache[67] = _createElementVNode("p", { class: "field-hint" }, "Puoi impostarla ora o successivamente dalla Dashboard.", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_123, [
                      _cache[68] || (_cache[68] = _createElementVNode("label", { class: "modal-label" }, "MODULI", -1)),
                      _createElementVNode("div", _hoisted_124, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['sat', 'lora', 'lte', 'plc'], (mod) => {
                          return _createElementVNode("label", {
                            key: mod,
                            class: "checkbox-label",
                            style: {"display":"flex","align-items":"center","gap":"8px","cursor":"pointer"}
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: mod,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((newDeviceForm.value.modules) = $event)),
                              style: {"width":"18px","height":"18px","accent-color":"#008f8f"}
                            }, null, 8, _hoisted_125), [
                              [_vModelCheckbox, newDeviceForm.value.modules]
                            ]),
                            _createTextVNode(" " + _toDisplayString(mod.toUpperCase()), 1)
                          ])
                        }), 64))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_126, [
              (newDeviceStep.value === 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-secondary",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (newDeviceStep.value = 1)),
                    style: {"background":"transparent","border":"1px solid #444","color":"#ccc"}
                  }, " Indietro "))
                : _createCommentVNode("", true),
              (newDeviceStep.value === 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: nextNewDeviceStep,
                    disabled: !isOtpSent.value || otpVerifyLoading.value
                  }, _toDisplayString(otpVerifyLoading.value ? "Verifica..." : "Avanti"), 9, _hoisted_127))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: confirmNewDevice
                  }, "Crea Device"))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})